import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Slider } from '@react-native-assets/slider'; // Importing the new slider library
import { themes } from 'src/theme/theme'; // Assuming you're using your theme for colors
import Typography from 'src/components/Text/Text';

type TpiSliderProps = {
  value: number;
  onValueChange: (value: number) => void;
  testID?: string;
};

const TpiSlider: React.FC<TpiSliderProps> = ({ value, onValueChange, testID }) => {
  // Custom thumb component with two circles (outer and inner)
  const CustomThumb = () => (
    <View style={styles.thumbContainer}>
      <View style={styles.outerCircle}>
        <View style={styles.innerCircle} />
      </View>
    </View>
  );

  return (
    <View style={styles.container}>
      <Slider
        testID={testID}
        style={styles.slider}
        minimumValue={0}
        maximumValue={100}
        step={5}
        value={value}
        onValueChange={onValueChange}
        minimumTrackTintColor={themes.light.brand_blue[3]}
        maximumTrackTintColor={themes.light.gray_blue[6]}
        thumbTintColor={themes.light.brand_blue[3]}
        CustomThumb={CustomThumb}
        trackHeight={4}
        thumbSize={32}
        slideOnTap={true}
      />
      {/* Percentage Label */}
      <Typography variant="h2" style={styles.sliderValueText}>{`${value}%`}</Typography>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    height: 48,
    paddingLeft: 16,
    alignItems: 'center',
  },
  slider: {
    height: 40,
    paddingLeft: 12,
    width: '85%',
    paddingRight: 24,
  },
  sliderValueText: {
    flex: 1,
    textAlign: 'right',
  },
  // Custom thumb styles
  thumbContainer: {
    width: 32,
    height: 32,
    borderRadius: 16,
    justifyContent: 'center',
    alignItems: 'center',
  },
  outerCircle: {
    width: 32,
    height: 32,
    borderRadius: 16,
    backgroundColor: themes.light.white[1],
    shadowColor: themes.light.black[1],
    shadowOffset: { width: 0, height: 0 },
    shadowOpacity: 0.3,
    shadowRadius: 5,
    elevation: 5,
    justifyContent: 'center',
    alignItems: 'center',
  },
  innerCircle: {
    width: 12,
    height: 12,
    borderRadius: 6,
    backgroundColor: themes.light.brand_blue[3],
  },
});

export default TpiSlider;
